import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose, DialogTrigger } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";

export default function DeleteProject({ projectId, projectTitle, onDeleted, triggerButtonProps = {} }) {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const { getToken } = useAuth()

    const handleDelete = async () => {
        setLoading(true)
        try {
            const token = await getToken()
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            }
            await axios.delete(api_endpoint + `/project/${projectId}`, reqConfig)
            toast.success(`Project "${projectTitle}" deleted successfully!`)
            setOpen(false)
            if (onDeleted) onDeleted(projectId)
        } catch (error) {
            toast.error(`Failed to delete project "${projectTitle}".`)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button
                    variant="outline"
                    size="sm"
                    className="text-red border-red hover:bg-blue hover:border-transparent hover:text-white"
                    {...triggerButtonProps}
                >
                    Delete Project
                </Button>
            </DialogTrigger>
            <DialogContent className="max-w-md h-auto bg-(--surface-panel) text-(--neutral-900)">
                <DialogHeader>
                    <DialogTitle className="font-heading">Delete Project</DialogTitle>
                </DialogHeader>
                <div className="font-body">
                    Are you sure you want to delete the project <b>{projectTitle}</b>? This action cannot be undone.
                </div>
                <DialogFooter className="">
                    <DialogClose asChild>
                        <Button variant="outline" onClick={() => setOpen(false)} disabled={loading} className="font-body">
                            Cancel
                        </Button>
                    </DialogClose>
                    <Button
                        onClick={handleDelete}
                        variant=""
                        disabled={loading}
                        className=""
                    >
                        {loading ? (
                                <span className="flex items-center justify-center w-full">
                                    <ClipLoader size={20} color="var(--neutral-50)" />
                                </span>
                            ) : (
                                "Delete"
                            )}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}